import { useQuery } from 'react-query';
import { dashboardService } from 'api/services';
import { QUERY_KEYS } from 'api/query-keys';
import { Site } from 'shared/hooks';
import { CACHE_TIME_LONG } from '../../../../shared/react-query/query-defaults';

export const useGetFillRateOfUpcomingShifts = (site: Site) => {
  return useQuery({
    queryKey: QUERY_KEYS.fillRateOfUpcomingShifts(),
    queryFn: () => dashboardService.getFillRateOfUpcomingShifts(site),
    cacheTime: CACHE_TIME_LONG,
  });
};
